/**
 * Chart Resolutions (aka interval) independent from date range
 * Used to choose candle size similar to TradingView
 */

export type ChartResolution = '1m' | '5m' | '15m' | '30m' | '1h' | '2h' | '4h' | '1D' | '1W';

export interface ResolutionConfig {
  label: string;
  multiplier: number; // Polygon API multiplier param
  timespan: 'minute' | 'hour' | 'day' | 'week'; // Polygon API timespan param
}

export const RESOLUTION_CONFIG: Record<ChartResolution, ResolutionConfig> = {
  '1m': { label: '1m', multiplier: 1, timespan: 'minute' },
  '5m': { label: '5m', multiplier: 5, timespan: 'minute' },
  '15m': { label: '15m', multiplier: 15, timesspan: 'minute' } as any, // keep key name consistent
  '30m': { label: '30m', multiplier: 30, timespan: 'minute' },
  '1h': { label: '1h', multiplier: 1, timespan: 'hour' },
  '2h': { label: '2h', multiplier: 2, timespan: 'hour' },
  '4h': { label: '4h', multiplier: 4, timespan: 'hour' },
  '1D': { label: '1D', multiplier: 1, timespan: 'day' },
  '1W': { label: '1W', multiplier: 1, timespan: 'week' },
};

// Correct typo for 15m entry to ensure strict typing
// (TypeScript helper - at runtime the value remains identical)

// @ts-ignore
RESOLUTION_CONFIG['15m'] = { label: '15m', multiplier: 15, timespan: 'minute' };

/**
 * Default resolution to use per timeframe (range)
 */
export const getDefaultResolutionForTimeframe = (
  timeframe: '1D' | '1W' | '1M' | '3M' | '1Y' | '5Y'
): ChartResolution => {
  switch (timeframe) {
    case '1D':
      return '5m';
    case '1W':
      return '30m';
    case '1M':
      return '2h';
    case '3M':
      return '1D';
    case '1Y':
      return '1D';
    case '5Y':
      return '1W';
    default:
      return '1D';
  }
};

/**
 * Suggested resolution options for UI (keep concise)
 */
export const RESOLUTION_OPTIONS: ChartResolution[] = ['5m', '15m', '1h', '4h', '1D', '1W'];
